/**
 * Provide a base component to extend for EdGEL plugins based on the
 * Bootstrap BaseComponent class.
 */

import BaseComponent from 'bootstrap/js/src/base-component.js'

/**
 * Constants
 */

const EdGELVersion = '__EDGEL_VERSION__'

/**
 * Class definition
 */

class EdGELBaseComponent extends BaseComponent {
  // Static
  static get VERSION() {
    const bsVersion = super.VERSION
    return `${bsVersion}+edgel-${EdGELVersion}`
  }
}

export default EdGELBaseComponent
